import PageHeader from "../components/PageHeader";
import HirePhpDeveloperContent from "../components/Hire-Php-Developer-Content";

const HirePhpDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Php Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Php Developer" image="/images/php-developer.jpg" />
            <HirePhpDeveloperContent />
        </>
    )
}

export default HirePhpDevelopers;